import { useState, useEffect, useCallback } from "react";
import { useSocialLoginAuth } from "../../../../hooks/authV2/useGoogleLogin.js";
import { loadFacebookSDK } from "../../../../utils/facebookSdk.js";
import { useNavigate, useSearchParams } from "react-router-dom";
import useHandleSuccess from "../../../../utils/parent/useHandleSuccess.js";

const FacebookLoginButton = ({ onHide }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect") || "";
  const tab = searchParams.get("tab") || "";

  const [sdkReady, setSdkReady] = useState(false);

  const { handleSuccess } = useHandleSuccess();
  const { socialLogin, loading, error } = useSocialLoginAuth("facebook");

  // Load Facebook SDK on mount
  useEffect(() => {
    loadFacebookSDK()
      .then(() => setSdkReady(true))
      .catch(() => {
        console.error("Failed to load Facebook SDK");
      });
  }, []);

  const fireLoginEvent = (userObj, roleLabel) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "login",
      method: "Facebook",
      user_email: userObj?.email || "",
      user_role: roleLabel || userObj?.role || "",
      user_name: userObj?.first_name || userObj?.name || "",
    });
  };

  const handleSuccessFun = useCallback(
    async (data) => {
      fireLoginEvent(data?.user);
      await handleSuccess({ data, redirect, tab, navigate });
      onHide();
    },
    [handleSuccess, redirect, tab, navigate, onHide],
  );

  const triggerFacebookLogin = useCallback(() => {
    if (!sdkReady || !window.FB) {
      return;
    }

    window.FB.login(
      (response) => {
        console.log(response);
        if (response.authResponse) {
          const accessToken = response.authResponse.accessToken;
          socialLogin(accessToken, handleSuccessFun);
        }
      },
      { scope: "email,public_profile" },
    );
  }, [sdkReady, socialLogin, handleSuccessFun]);

  return (
    <>
      <button
        className="auth-social-btn facebook"
        type="button"
        onClick={triggerFacebookLogin}
        disabled={loading}
      >
        <i className="fa-brands fa-facebook-f"></i>
        {loading ? "Signing in..." : "Continue with Facebook"}
      </button>
      {error && (
        <div
          className="text-danger text-center mb-2"
          style={{ fontSize: "14px" }}
        >
          {error}
        </div>
      )}
    </>
  );
};

export default FacebookLoginButton;
